import React from 'react'
import './gallery.min.css'
import './gallery.theme.css'
import './bootstrap.css'
import './styles.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import Helmet from 'react-helmet'
import Title from '../components/Title'
import NavBar from '../components/NavBar'
import Header from '../components/Header'
import Footer from '../components/Footer'

const Index = () => {
    return (
        
         <div className='pageStyle'>
            <Helmet>
                <Title />
            </Helmet>
            <NavBar />
            <Header />
            <Footer />  
        </div>
    )
}
export default Index